export default "__VITE_ASSET__704d18e0__"